<script lang="ts">
	interface Props {
		height?: string; // Default height
		width?: string; // Default width
		class?: string;
	}

	let { height = '48px', width = '48px', class: className = '' }: Props = $props();

</script>

<svg
	{height}
	{width}
	class={className}
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M21.141 6.323C20.6756 5.98741 20.0768 5.89693 19.533 6.08C19.4296 6.11332 19.3594 6.20937 19.359 6.318V11.238C19.359 11.5141 19.1351 11.738 18.859 11.738C18.5829 11.738 18.359 11.5141 18.359 11.238V4.738C18.3584 4.17897 18.0918 3.65358 17.641 3.323C17.1755 2.98757 16.5768 2.8971 16.033 3.08C15.9296 3.11332 15.8594 3.20937 15.859 3.318V9.738C15.859 10.0141 15.6351 10.238 15.359 10.238C15.0829 10.238 14.859 10.0141 14.859 9.738V2.738C14.8579 1.77196 14.075 0.989101 13.109 0.987999C12.9081 0.986936 12.7087 1.02322 12.521 1.095C12.4237 1.13128 12.3591 1.22415 12.359 1.328V9.738C12.359 10.0141 12.1351 10.238 11.859 10.238C11.5829 10.238 11.359 10.0141 11.359 9.738V4.738C11.359 4.11278 11.0255 3.53506 10.484 3.22245C9.94255 2.90985 9.27545 2.90985 8.734 3.22245C8.19255 3.53506 7.859 4.11278 7.859 4.738V14.738C7.85895 14.8507 7.78432 14.9498 7.676 14.981C7.57293 15.0108 7.46246 14.9703 7.403 14.881L5.283 11.91C4.72768 11.1291 3.64443 10.9462 2.8635 11.5015C2.08257 12.0568 1.89968 13.1401 2.455 13.921L7.925 21.64C8.53645 22.498 9.52539 23.007 10.579 23.006H15.615C19.0626 22.9983 21.8546 20.2036 21.859 16.756V7.738C21.8584 7.17897 21.5918 6.65358 21.141 6.323V6.323Z"
		fill="currentColor"
	/>
</svg>
